import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ContactRole, IDVData } from '@shared/models/data-model';
import { IdvService } from '@shared/services/idv.service';
import { RegistrationService } from '@shared/services/registration.service';

export interface VerificationPortalData {
    portalLink: string;
    multipleVerifications: boolean;
    inEarlyAccessPhase: boolean;
}

export const verificationPortalResolver: ResolveFn<VerificationPortalData> = async (route, state) => {
    const registrationService = inject(RegistrationService);
    const idvService = inject(IdvService);
    const applicant = await registrationService.getApplicant();
    const idvData: IDVData[] = await idvService.loadApplicationIDVData(applicant.contactId).catch(() => null);
    const contacts = (await registrationService.getAllContacts())
        .filter(c => c.roles.some(role => [ContactRole.Admin,ContactRole.Applicant,ContactRole.LegalRepresentative].includes(role)));
    const portalLink = idvData.find(idvData => idvData.contactId === applicant.contactId)?.idvReference ??
                            idvData[0].idvReference;
    const multipleVerifications = contacts.length > 1;
    const complianceData = await registrationService.getComplianceData();
    return {
        portalLink: portalLink,
        multipleVerifications: multipleVerifications,
        inEarlyAccessPhase: Boolean(complianceData.inEarlyAccessPhase)
    };
};
